class MegaMenu extends HTMLElement {
  constructor() {
    super();
    var menuItems = this.querySelectorAll('[data-index]');
    var subMenus = this.querySelectorAll('[data-sub-menu]');
    var page = document.getElementById('MainContent');
    var header = document.querySelector('header');

    menuItems.forEach((item) => {
      item.addEventListener('mouseover', () => {
        setTimeout(() => this.revealHeader(item, subMenus, menuItems), 200);
      });
    });
    subMenus.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        var dataFlag = item.getAttribute('data-main');
      });
      item.addEventListener('mouseleave', () => {
        this.closeMenus(menuItems, subMenus);
      });
    });
    header.addEventListener('mouseenter', () => {
      this.closeMenus(menuItems, subMenus);
    });
    page.addEventListener('mouseenter', () => {
      this.closeMenus(menuItems, subMenus);
    });
  }

  revealHeader(item, subMenus, menuItems) {
    this.closeMenus(menuItems, subMenus);
    var selector = item.getAttribute('data-index');
    var menuToOpen = this.querySelector('[data-sub-' + selector + ']');
    if (menuToOpen) menuToOpen.classList.remove('hidden');
  }

  closeMenus(menuItems, subMenus) {
    subMenus.forEach((item) => {
      item.classList.add('hidden');
    });
  }
}

if (!customElements.get('mega-menu')) {
  customElements.define('mega-menu', MegaMenu);
}
